import { animated } from 'react-spring'

const ShortArrow = ({ transform, shortArrowProps, step, direction, fade }) => {
  return (
    <g transform={transform}>
      <animated.line
        className={`short-line dashed step-${step} ${direction}`}
        x1={0}
        y1={0}
        x2={0}
        //y2={inFrame === 'out' || direction === 'up' ? -50 : shortArrowProps.y2}
        y2={fade || direction === 'up' ? -50 : shortArrowProps.y2}
      />
      {/* arrow head */}
      <animated.g
        transform={
          //inFrame === 'out' || direction === 'up'
          fade || direction === 'up'
            ? 'translate(-10, -50)'
            : shortArrowProps.translate
        }
      >
        <line
          className={`short-line step-${step} ${direction}`}
          x1={10}
          y1={0}
          x2={0}
          y2={10}
        />
        <line
          className={`short-line step-${step} ${direction}`}
          x1={10}
          y1={0}
          x2={20}
          y2={10}
        />
      </animated.g>
    </g>
  )
}

export default ShortArrow
